module.exports = __webpack_public_path__ + "static/img/winter_banner.ec4d076d.jpg";